import theme from '@styles/theme';
export default {
  brandSliderContainer: {
    zindex: theme.zIndex.documentUp,
    position: 'relative',
    height: ['auto', 'auto', '1024px', 'auto'],
    '.swiper': {
      height: ['716px', '716px', 'auto', 'auto'],
      position: 'relative'
    },
    '.swiper-slide': {
      opacity: '0',
      zIndex: theme.zIndex.documentUp
    },
    '.swiper-slide-active': {
      opacity: '1',
      zIndex: theme.zIndex.documentUp + 1
    }
  },
  brandSliderControlArrowsContainer: {
    'vox-button': {
      transform: ['translateY(105px)', 'translateY(0)']
    }
  }
};